<phone-book fxLayout="column" fxFlex="noshrink" [showFilter]="true"></phone-book>
